require('promise-polyfill');
require('isomorphic-fetch');
var merge = require('./helpers/merge');
var timeoutPromise = require('./helpers/timeout-promise');
var URL = 'https://oji7prpx5h.execute-api.us-west-2.amazonaws.com/staging/v1';

/**
 * @class BabouJS
 */
function BabouJS() {
    this.api_key = undefined;
    this.URL = URL;
}

/**
 * Sets the babou API Key
 *
 * @function setApiKey
 * @param {String} api_key
 */
function setApiKey(api_key) {
    this.api_key = api_key;
}
BabouJS.prototype.setApiKey = setApiKey;

/**
 * Allows you to manually override the base URL. By default
 * it will be https://wilq5cq0w8.execute-api.us-west-2.amazonaws.com/production/babou
 *
 * @function setURL
 * @param {String} url
 */
function setURL(url) {
    this.URL = url;
}
BabouJS.prototype.setURL = setURL;

/**
 * Allows you to set the API Key and Base URL in one call
 *
 * @function setConfig
 * @param {Object} config
 */
function setConfig(config) {
    if(!config) return this;
    if(config.url) this.setURL(config.url);
    if(config.api_key) this.setApiKey(config.api_key);
    return this;
}
BabouJS.prototype.setConfig = setConfig;

/**
 * By default it will include the preferred_profile of
 * the agent.
 *
 * @function getPreferredAgent
 * @param {Object} agent
 * @param {Object} [options]
 * @param {Boolean} [options.cache=true]
 * @param {Boolean} [options.include_followers=false]
 * @param {Boolean} [options.include_aliases=false]
 * @param {Boolean} [options.include_listings=false]
 * @param {Boolean} [options.include_listing_stats=false]
 * @param {Boolean} [options.include_buys=false]
 * @param {Boolean} [options.include_buying_stats=false]
 * @param {Boolean} [options.include_last_sold=false]
 * @param {Boolean} [options.include_last_listing=false]
 * @param {int} [options.include_new_listings=0] - Number of new listings to return
 * @param {int} [options.include_open_houses=0] - Number of listings with open houses to return
 * @param {int} [options.timeout=10000] - time in MS
 * @param {int} [options.retries=0] - The number of retries to do before its considered a fail
 */
function getPreferredAgent(agent, options) {
    var defaultOptions = {
        cache: true,
        include_followers: false,
        include_aliases: false,
        include_listings: false,
        include_listing_stats: false,
        include_buys: false,
        include_buying_stats: false,
        include_last_sold: false,
        include_last_listing: false,
        timeout: 10000,
        retries: 0
    }
    options = merge(defaultOptions, options);
    var body = {
        "agent": agent,
        "options": options
    }
    var URL = this.URL;
    var API_KEY = this.api_key;

    return _startFetch();

    /**
     * An internal function used to allow retries
     *
     * @function _startFetch
     * @param {int} retryCount
     */
    function _startFetch(retryCount) {
        retryCount = retryCount || 0;
        var promise = fetch([URL, '/agent'].join(''), {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': API_KEY
            },
            body: JSON.stringify(body),
        });

        if(!!options.timeout) {
            promise = timeoutPromise(parseInt(options.timeout), new Error('Timed Out!'), promise);
        }

        return promise
        .then(function (response) {
            if (response.status >= 400) {
                throw new Error("Bad response from server");
            }

            return response.json();
        })
        .then(function(jsonObj) {
            if (Object.prototype.hasOwnProperty.call(jsonObj, 'data')) {
                return jsonObj.data;
            }

            return jsonObj;
        })
        .catch(function onError(err) {
            retryCount++;

            if(retryCount > options.retries) {
                throw err;
            } else {
                return _startFetch(retryCount);
            }
        });
    }
}
BabouJS.prototype.getPreferredAgent = getPreferredAgent;


/**
 *
 *
 *
 * @function searchListings
 * @param {Object[]} areas - The areas we want to search listings in
 * @param {Object} [options]
 * @param {Boolean} [options.cache=true]
 * @param {Boolean} [options.include_listings=false]
 * @param {Boolean} [options.include_listing_stats=false]
 * @param {Boolean} [options.include_market_segments=false]
 * @param {Boolean} [options.enhance_listings_with_preferred_vendor_ids=true] - Enhance listings with preferred vendor id
 * @param {Boolean} [options.useSourceZipBlacklist=false] - flag to use source zipcode blacklist
 * @param {String} [options.orderBy=ListingDate:desc] - can sort by 'ListingDate:desc', 'ListPrice:desc', 'ListPrice:asc', or 'OpenHouseDate:asc'
 * @param {int} [options.limit=48] - number of listings per page
 * @param {int} [options.skip=0] - go to page that includes this record
 * @param {int} [options.timeout=10000] - time in MS
 * @param {int} [options.initial_retry_delay=500] - time in MS, every retry will wait 2x as the last delay
 * @param {int} [options.include_new_listings=0] - Number of new listings to return
 * @param {int} [options.include_open_houses=0] - Number of listings with open houses to return

 * @param {int} [options.retries=0] - The number of retries to do before its considered a fail
 */
function searchListings(areas, options) {
    var defaultOptions = {
        cache: true,
        include_listings: false,
        include_listing_stats: true,
        include_market_segments: false,
        enhance_listings_with_preferred_vendor_ids: false,
        include_open_houses: false,
        useSourceZipBlacklist: false,
        orderBy: 'ListingDate:desc',
        limit: 48,
        skip: 0,
        timeout: 10000,
        include_new_listings: 0,
        include_abn_buyers: 0,
        initial_retry_delay: 500,
        retries: 0
    }

    var mergedOptions = merge(defaultOptions, options);
    var body = {
        "areas": areas,
        "options": mergedOptions
    }
    var URL = this.URL;
    var API_KEY = this.api_key;

    return _startFetch();

    /**
     * An internal function used to allow retries
     *
     * @function _startFetch
     * @param {int} retryCount
     */
    function _startFetch(retryCount) {
        retryCount = retryCount || 0;
        initial_delay = parseInt(mergedOptions.initial_retry_delay) || 500;

        var bodyJson = JSON.stringify(body);
        var promise = fetch([URL, '/listings/search'].join(''), {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': API_KEY
            },
            body: bodyJson,
        });

        // for next retry, we want pickup where we left off
        mergedOptions.cache = true;

        if(!!options.timeout) {
            promise = timeoutPromise(
                parseInt(mergedOptions.timeout),
                new Error('Timed Out!'),
                promise
            );
        }

        return promise
        .then(function (response) {
            if (response.status >= 400) {
                throw new Error("Bad response from server");
            }

            return response.json();
        })
        .catch(function onError(err) {
            retryCount++;

            if(retryCount > mergedOptions.retries) {
                throw err;
            } else {
                // On retries, cache is true so we can pick up
                // where we left off on the last try
                delay = (
                    (initial_delay || 0) *
                    Math.pow(2, retryCount - 1)
                );

                return new Promise(function(resolve, reject){
                    setTimeout(
                        function(){
                            _startFetch(retryCount)
                            .then(resolve)
                            .catch(reject);
                        },
                        delay
                    )
                });
            }
        });
    }
}
BabouJS.prototype.searchListings = searchListings;


/**
 * Fetches listings similar to the address provided
 *
 *
 * @function getSimilarListings
 * @param {Object} [params]
 * @param {String} [params.address] - The address to look for
 * @param {Object} [params.orderBy] - whether to sort using any of the keys available in elasticsearch
 *
*/
function getSimilarListings(params) {
    const options = { params: params };
    return this.callApi('/listings/similar', options);
}
BabouJS.prototype.getSimilarListings = getSimilarListings;


/**
 *
 *
 *
 * @function buyerStats
 * @param {Object[]} areas - The areas we want to search listings in
 * @param {Object} [options]
 * @param {Boolean} [options.cache=true]
 * @param {int} [options.timeout=10000] - time in MS
 * @param {int} [options.initial_retry_delay=500] - time in MS, every retry will wait 2x as the last delay
 * @param {int} [options.retries=0] - The number of retries to do before its considered a fail
 */
function buyerStats(areas, options) {
    var defaultOptions = {
        cache: true,
        timeout: 10000,
        initial_retry_delay: 500,
        retries: 0
    }

    var mergedOptions = merge(defaultOptions, options);
    var body = {
        "areas": areas,
        "options": mergedOptions
    }
    var URL = this.URL;
    var API_KEY = this.api_key;

    return _startFetch();

    /**
     * An internal function used to allow retries
     *
     * @function _startFetch
     * @param {int} retryCount
     */
    function _startFetch(retryCount) {
        retryCount = retryCount || 0;
        initial_delay = parseInt(mergedOptions.initial_retry_delay) || 500;

        var bodyJson = JSON.stringify(body);
        var promise = fetch([URL, '/sold/stats'].join(''), {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': API_KEY
            },
            body: bodyJson,
        });

        // for next retry, we want pickup where we left off
        mergedOptions.cache = true;

        if(!!options.timeout) {
            promise = timeoutPromise(
                parseInt(mergedOptions.timeout),
                new Error('Timed Out!'),
                promise
            );
        }

        return promise
        .then(function (response) {
            if (response.status >= 400) {
                throw new Error("Bad response from server");
            }

            return response.json();
        })
        .catch(function onError(err) {
            retryCount++;

            if(retryCount > mergedOptions.retries) {
                throw err;
            } else {
                // On retries, cache is true so we can pick up
                // where we left off on the last try
                delay = (
                    (initial_delay || 0) *
                    Math.pow(2, retryCount - 1)
                );

                return new Promise(function(resolve, reject){
                    setTimeout(
                        function(){
                            _startFetch(retryCount)
                            .then(resolve)
                            .catch(reject);
                        },
                        delay
                    )
                });
            }
        });
    }
}
BabouJS.prototype.buyerStats = buyerStats;


/**
 *
 *
 *
 * @function searchAgents
 * @param {String} type - The type of activity we are searching. Can be either 'listing' or 'seller'
 * @param {Object[]} areas - The areas we want to search activity in
 * @param {Object} [options] - Super set of getPreferredAgent
 * @param {Boolean} [options.cache=true] - Flag to use cached data
 * @param {String} [options.orderBy=preferred_profile.name:desc] - pass through to lodash orderBy. Can sort by result before being enhanced by getPreferredAgent options
 * @param {int} [options.limit=30] - number of agents per page
 * @param {int} [options.skip=0] - go to page that includes this record
 * @param {Boolean} [options.include_listing_stats=false]
 * @param {Boolean} [options.include_followers=false]
 * @param {Boolean} [options.include_aliases=false]
 * @param {Boolean} [options.include_buying_stats=false]
 * @param {Boolean} [options.include_buys=false]
 * @param {Boolean} [options.include_last_sold=false]
 * @param {Boolean} [options.include_last_listing=false]
 * @param {int} [options.include_new_listings=0] - Number of new listings to return
 * @param {int} [options.include_open_houses=0] - Number of listings with open houses to return
 * @param {int} [options.timeout=10000] - time in MS
 * @param {int} [options.initial_retry_delay=500] - time in MS, every retry will wait 2x as the last delay
 * @param {int} [options.retries=0] - The number of retries to do before its considered a fail
 */
function searchAgents(type, areas, options) {
    var defaultOptions = {
        cache: true,
        include_listings: false,
        include_listing_stats: false,
        include_aliases: false,
        include_buying_stats: false,
        include_buys: false,
        include_last_sold: false,
        include_last_listing: false,
        include_open_houses: 0,
        orderBy: 'preferred_profile.name:desc',
        limit: 48,
        skip: 0,
        timeout: 10000,
        include_new_listings: 0,
        include_abn_buyers: 0,
        initial_retry_delay: 500,
        retries: 0
    }

    var mergedOptions = merge(defaultOptions, options);
    var body = {
        "query": {"areas": areas, "type": type},
        "options": mergedOptions
    }
    var URL = this.URL;
    var API_KEY = this.api_key;

    return _startFetch();

    /**
     * An internal function used to allow retries
     *
     * @function _startFetch
     * @param {int} retryCount
     */
    function _startFetch(retryCount) {
        retryCount = retryCount || 0;
        initial_delay = parseInt(mergedOptions.initial_retry_delay) || 500;

        var bodyJson = JSON.stringify(body);
        var promise = fetch([URL, '/agents/search'].join(''), {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': API_KEY
            },
            body: bodyJson,
        });

        // for next retry, we want pickup where we left off
        mergedOptions.cache = true;

        if(!!options.timeout) {
            promise = timeoutPromise(
                parseInt(mergedOptions.timeout),
                new Error('Timed Out!'),
                promise
            );
        }

        return promise
        .then(function (response) {
            if (response.status >= 400) {
                throw new Error("Bad response from server");
            }

            return response.json();
        })
        .catch(function onError(err) {
            retryCount++;

            if(retryCount > mergedOptions.retries) {
                throw err;
            } else {
                // On retries, cache is true so we can pick up
                // where we left off on the last try
                delay = (
                    (initial_delay || 0) *
                    Math.pow(2, retryCount - 1)
                );

                return new Promise(function(resolve, reject){
                    setTimeout(
                        function(){
                            _startFetch(retryCount)
                            .then(resolve)
                            .catch(reject);
                        },
                        delay
                    )
                });
            }
        });
    }
}
BabouJS.prototype.searchAgents = searchAgents;


/**
 * Allows you to call a babou API using fetch
 *
 *
 * @function callApi
 * @param {String} path - The Babou Path to hit
 * @param {Object} [options] - All fetch options are available to be passed in here
 * @param {Object} [options.params] - fetch does not allow query string params,
 * but we allow that in the options object here

*/
function callApi(path, options) {
    // if '/' wasn't passed in the path, add it to the path
    if(path[0] !== '/') path = '/' + path;

    // add parameters since fetch doesn't do it for us
    if(options.params && Object.keys(options.params).length) {
        var esc = encodeURIComponent;
        var query = Object.keys(options.params)
            .map(function(k) { return esc(k) + '=' + esc(options.params[k]) })
            .join('&');
        path = path + '?' + query;
        delete options.params;
    }

    // set the auth headers
    if(!options.headers) options.headers = {};
    options.headers['Content-Type'] = 'application/json';
    options.headers['x-api-key'] = this.api_key;

    var url = [this.URL, path].join('');
    return fetch(url, options)
    .then(function (response) {
        if (response.status >= 400) {
            throw new Error('Bad response from server');
        }

        return response.json();
    });
};
BabouJS.prototype.callApi = callApi;


module.exports = new BabouJS();
